<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>
      小植物版权所有，备案号:<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">闽ICP备2021013367号-1</a>.
    </p>
    <h5>copyrights © 2021 smallplants.cn. all rights reserved.</h5>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
